import { isUndefined } from "lodash";
import { Item } from "./Categories";

export type CategorizedItems = {
  [key: string]: Item[];
};

export const categorizeItems = (items: Item[]) => {
  const categorizedItems: CategorizedItems = {
    unCategorized: [],
  };

  items.forEach((item) => {
    if (item.category) {
      if (categorizedItems[item.category]) {
        categorizedItems[item.category].push(item);
      } else {
        categorizedItems[item.category] = [];
        categorizedItems[item.category].push(item);
      }
    } else {
      categorizedItems["unCategorized"].push(item);
    }
  });

  return categorizedItems;
};

export const findValueLabel = (
  items: Item[],
  value: string | string[] | Item,
  initialValue?: Item | Item[],
  detailedValue?: boolean,
  allowUndefinedAsItemValue?: boolean,
) => {
  if (!allowUndefinedAsItemValue && isUndefined(value)) return "";

  const itemsWithIntial = [
    ...items,
    ...(initialValue
      ? Array.isArray(initialValue)
        ? initialValue
        : [initialValue]
      : []),
  ];
  if (!Array.isArray(value)) {
    const valueToCheck = detailedValue ? (value as Item).id : value;
    const matchedValue = itemsWithIntial.find(
      (item) => item.id?.toString() === valueToCheck?.toString(),
    );

    return matchedValue ? matchedValue.label : "";
  }

  return value
    .map((val: string | Item) => {
      const valueToCheck = detailedValue ? (val as Item).id : val;
      const matchedValue = itemsWithIntial.find(
        (item) => item.id === valueToCheck,
      );

      return matchedValue ? matchedValue.label : "";
    })
    .join(", ");
};

export const isValueSelected = (
  item: Item,
  value?: string | string[] | Item | Item[],
  keepDetailedValue?: boolean,
) => {
  if (!value) return false;
  const valueToCheck = keepDetailedValue ? (value as Item).id : value;

  if (!Array.isArray(value)) {
    return item.id?.toString() === valueToCheck?.toString();
  }

  return !!(value as string[]).find((val: string | Item) => {
    const valueToCheck = keepDetailedValue ? (val as Item).id : val;
    return valueToCheck === item.id;
  });
};

export const filterElements = (items: Item[], searchQuery: string) => {
  return [...items].filter((item) =>
    item.label?.toLowerCase().includes(searchQuery.toLowerCase()),
  );
};
